// extracted by mini-css-extract-plugin
export default {"cls1":"Comments-cls1_ppH","cls2":"Comments-cls2_rjP Comments-cls1_ppH"};